import { axiosInstance } from "../utils/axiosInstance";
import { TLoginResponseData, LoginRequest, PasswordRecoverRequest, PasswordChangeRequest } from "../types/loginTypes";

const LoginAPI = {
  Login: async (login: string, password: string) => {    
    const request: LoginRequest = {
      Login: login,
      Password: password   
    };
    const loginResult = await axiosInstance.post<TLoginResponseData>(
      `Login/WebVisitLogin`, request
    );
    return loginResult;
  },
  ChangePassword: async (pass: string, hash: string) => {
    const request: PasswordChangeRequest = {
      Password: pass,
      Hash: hash
    };
    const changeResult = await axiosInstance.post<any>(
      `Folio/ChangePassword`, request
    );   
    return changeResult;
  },
  RecoverPassword: async (login: string) => {
    const request: PasswordRecoverRequest = {
      Email: login,
    };
      const recoverResult = axiosInstance.post<any>(
        `Folio/SendChangePasswordLinkForWebVisit`, request
      );    
    return recoverResult;
  },
  ValidatePassHash: async (hash: string) => {   
    const validationResult = await axiosInstance.get(      
      "Note/ValidatePasswordHash?hash=" + hash
    );    
    return validationResult;
  },  
};

export default LoginAPI;